import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnDestroy,
  Output,
  SimpleChanges,
} from "@angular/core";
import { NavController } from "@ionic/angular";
import { NavigationStart, Router } from "@angular/router";
import { filter, Subscription } from "rxjs";
import {
  DemandDevisWaitService,
  DemandWaitTransition,
} from "src/app/_services/demand-devis-wait.service";
import { PusherService } from "src/app/_services/pusher.service";

@Component({
  selector: "app-demand-wait-overlay",
  templateUrl: "./demand-wait-overlay.component.html",
  styleUrls: ["./demand-wait-overlay.component.scss"],
  standalone: false,
})
export class DemandWaitOverlayComponent implements OnChanges, OnDestroy {
  @Input() isOpen = false;
  @Input() demandId: number | null = null;
  @Input() showReportButton = true;

  @Output() devisReady = new EventEmitter<number>();
  @Output() canceled = new EventEmitter<number>();
  @Output() problemDetected = new EventEmitter<number>();
  @Output() meetingPending = new EventEmitter<{ demandeId: number; meetings: unknown[] }>();
  @Output() closed = new EventEmitter<void>();

  message = "MESSAGE.LOADING_1";
  showMeetModal = false;
  meetResource: any[] | undefined;

  private waitSub?: Subscription;
  private applySub?: Subscription;
  private routerSub?: Subscription;

  constructor(
    private demandDevisWaitService: DemandDevisWaitService,
    private pusherService: PusherService,
    private navController: NavController,
    private router: Router
  ) {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes["isOpen"] || changes["demandId"]) {
      if (this.isOpen && this.demandId != null) {
        this.startWait(Number(this.demandId));
      } else {
        this.stopWait();
      }
    }
  }

  ngOnDestroy(): void {
    this.stopWait();
  }

  goToProblemReport(): void {
    if (this.demandId == null) {
      return;
    }
    void this.navController.navigateForward([`/particulier/problem/${this.demandId}`]);
  }

  private startWait(demandId: number): void {
    this.stopWait();
    this.message = "MESSAGE.LOADING_1";
    this.showMeetModal = false;
    this.bindNavigationDismiss();

    this.applySub = this.pusherService.ProviderApplyinDevisObservable().subscribe((res: any) => {
      if (Number(res?.demande_id) !== demandId) {
        return;
      }
      switch (res?.type) {
        case "DEVIS":
          this.message = "MESSAGE.LOADING_2";
          break;
        case "RELANCE":
          this.message = "MESSAGE.LOADING_3";
          break;
        case "SIGNAL":
          this.message = "MESSAGE.LOADING_4";
          break;
      }
    });

    this.waitSub = this.demandDevisWaitService.waitForDevisTransition(demandId).subscribe({
      next: (transition) => this.handleTransition(transition),
      error: () => {
        this.closed.emit();
      },
    });
  }

  private handleTransition(transition: DemandWaitTransition): void {
    const demandeId = transition.demandeId ?? this.demandId ?? undefined;
    switch (transition.type) {
      case "devis":
        if (transition.devisId != null) {
          this.devisReady.emit(transition.devisId);
        }
        break;
      case "canceled":
        if (demandeId != null) {
          this.canceled.emit(demandeId);
        }
        break;
      case "problem":
        if (demandeId != null) {
          this.problemDetected.emit(demandeId);
        }
        break;
      case "meeting":
        this.meetResource = (transition.meetings as any[]) ?? undefined;
        this.showMeetModal = true;
        if (demandeId != null && transition.meetings) {
          this.meetingPending.emit({
            demandeId,
            meetings: transition.meetings,
          });
        }
        break;
    }
  }

  private bindNavigationDismiss(): void {
    this.routerSub?.unsubscribe();
    this.routerSub = this.router.events
      .pipe(filter((event) => event instanceof NavigationStart))
      .subscribe(() => {
        this.closed.emit();
      });
  }

  private stopWait(): void {
    this.waitSub?.unsubscribe();
    this.applySub?.unsubscribe();
    this.routerSub?.unsubscribe();
    this.waitSub = undefined;
    this.applySub = undefined;
    this.routerSub = undefined;
    this.demandDevisWaitService.stopWait();
  }
}
